import moment from 'moment'

export const setTime = time => {
   const parts = time.split(' ')
   const datePart = parts[0]
   const [day, month, year] = datePart.split('-')

   let newDate
   if (parts.length > 1) {
      const timePart = parts[1]
      const [hour, minute] = timePart.split(':')
      newDate = new Date(year, parseInt(month) - 1, day, hour, minute)
   } else {
      newDate = new Date(year, parseInt(month) - 1, day)
   }
   return newDate.toString()
}

export const duplicateRoles = (allRAndG, rolList) => {
   const duplicatedRoles = []
   if (allRAndG?.roles) {
      // Utilizamos un mapa para realizar un seguimiento de los elementos que hemos visto en rolList
      const seenRoles = new Map()
      // Iteramos a través de rolList y registramos los elementos duplicados en duplicatedRoles
      for (const role of rolList) {
         const key = `${role?.id}_${role?.name}`
         if (seenRoles.has(key)) {
            duplicatedRoles.push(role)
         } else {
            seenRoles.set(key, role)
         }
      }
      // Iteramos a través de allRolesAndGroup?.roles y hacemos lo mismo
      for (const role of allRAndG?.roles) {
         const key = `${role?.id}_${role?.name}`
         if (seenRoles.has(key)) {
            duplicatedRoles.push(role)
         } else {
            seenRoles.set(key, role)
         }
      }
   }
   return duplicatedRoles
}

export const sendQuestToAPIMapper = dataPayload => ({
   name: dataPayload?.name,
   description: dataPayload?.description,
   subdomainId: dataPayload?.subdomainId?.id,
   applicationId: dataPayload?.applicationId?.id,
   finalDate: moment(dataPayload?.finalDate)
      .format('YYYY-MM-DD')
      .startsWith('Fecha')
      ? ''
      : moment(dataPayload?.finalDate).format('YYYY-MM-DD'),
   // roles: dataPayload.roleId?.id ?? '',
   // groups: dataPayload.groupId?.id ?? '',
   roles: dataPayload?.roleId?.map(role => role?.id) ?? [],
   groups: dataPayload?.groupId?.map(group => group?.id) ?? [],
   functionality: dataPayload?.functionality?.id,
   initialDate:
      moment(dataPayload?.initialDate)
         .format('YYYY-MM-DD')
         .startsWith('Fecha') ||
      moment(dataPayload?.time).format('HH:mm').startsWith('Fecha')
         ? ''
         : `${moment(dataPayload?.initialDate).format('YYYY-MM-DD')}T${moment(
              dataPayload?.time
           ).format('HH:00')}` ?? ''
})
